var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,14.5c-1.4,0-2.5-1.1-2.5-2.5V8.8H4V12c0,2.2,1.8,4,4,4s4-1.8,4-4V8.8h-1.5V12C10.5,13.4,9.4,14.5,8,14.5z\n\t M8.8,11.2V4.8H7.2v6.4H8.8z M4,4v3.2h1.5V4c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v3.2H12V4c0-2.2-1.8-4-4-4S4,1.8,4,4z","fill":"currentColor"}));
}

Link.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Link;

Link.default = Link;
